import PlayerSection from './PlayerSection';

export default PlayerSection;
